import { Tenant, UpdateTenantInfo } from '~/types/Tenant';
import { Gateway } from './gateway';
import { authenticatingNetworkManager } from './network/authenticatingNetworkManager';
import { MagicRequest, RequestMethod } from './network/magicRequest';

const TENANT_URL = '/api/me';

class TenantGateway extends Gateway {
  public getTenantInfo = async (): Promise<Tenant> => {
    const request: MagicRequest = {
      url: TENANT_URL,
      method: RequestMethod.GET,
      headers: this.createCommonHeaders(),
    };
    const response: Response = await this.sendRequest(request);
    const json = await response.json();
    return {
      id: json.id,
      email: json.email,
      firstName: json.firstName,
      lastName: json.lastName,
      phoneNumber: json.phone,
      lastSeen: json.lastSeen,
      chatId: json.chatId,
      language: json.language,
    };
  };

  public updatedTenantInfo = async (tenant: UpdateTenantInfo): Promise<void> => {
    const request: MagicRequest = {
      url: TENANT_URL,
      method: RequestMethod.PUT,
      headers: this.createCommonHeaders(),
      body: JSON.stringify(tenant),
    };
    await this.sendRequest(request);
  };
}

export const tenantGateway = new TenantGateway(authenticatingNetworkManager);
